import axios from "axios";
import { supabase } from "../supabaseClient";
import { getBackend } from "../utils/getBackend";
import { getAccessTokenHeader } from "./helper/getAccessTokenHeader";

interface GenerateCaptionsRequest {
  imageUrls: string[];
  numCaptions?: number;
  additionalInfo?: string;
}

interface GenerateCaptionsResponse {
  captions: string[];
  error?: string;
}

export async function generateCaptions({
  imageUrls,
  numCaptions = 3,
  additionalInfo = "",
}: GenerateCaptionsRequest): Promise<GenerateCaptionsResponse> {
  try {
    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (sessionError || !session) {
      throw new Error("Not authenticated");
    }

    const response = await axios.post(
      getBackend() + "/ai/prompts/captions",
      {
        imageUrls,
        numCaptions,
        additionalInfo,
      },
      {
        headers: await getAccessTokenHeader(),
      }
    );

    const result = response.data;

    console.log("result", result);

    return result;
  } catch (error) {
    console.error("Failed to generate captions:", error);
    return {
      captions: [],
      error:
        error instanceof Error ? error.message : "Failed to generate captions",
    };
  }
}
